import * as exNotify from './notify';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showNotify(config: Record<string, any>): void;
        updateNotify(config: Record<string, any>): void;
        hideNotify(config: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showNotify = function (config: Record<string, any>): void {
    exNotify.show(this, config);
};

HTMLElement.prototype.updateNotify = function (config: Record<string, any>): void {
    exNotify.update(this, config);
};

HTMLElement.prototype.hideNotify = function (config: Record<string, any>): void {
    exNotify.hide(this, config);
};
